import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import { Input } from 'ui-components/components/input';
import { dangerousGoods } from '../../../../../../services/other-shipping-options/constants';
import { DangerousGoodsRow } from '../dangerous-goods-row';
import { messages } from './messages';
import styles from './styles.module.less';

/**
 * @typedef {import('ui-components/components/checkbox').CheckboxChangeHandler} CheckboxChangeHandler
 */

/**
 * Component for handling dangerous goods shipping option.
 * @param {object} props - The component props.
 * @param {React.ReactNode} props.label - The label for the checkbox.
 * @param {boolean} props.checked - The checked state of the checkbox.
 * @param {{contactName: string, contactPhone: string}} props.optionData - The data for the dangerous goods option.
 * @param {CheckboxChangeHandler} props.onCheck - The function to handle checkbox change event.
 * @param {(arg: { id: string, value: { contactName: string, contactPhone: string }}) => void} props.updateOption - The function to update the dangerous goods option.
 * @param {(arg: { id: string, value: { contactName: string, contactPhone: string }}) => void} props.updateInput - The function to update the dangerous goods input.
 * @returns {JSX.Element} The rendered DangerousGoods component.
 */
export const DangerousGoods = ({ label, checked = false, onCheck, optionData, updateInput, updateOption }) => {
  const onBlur = (property) => {
    return (event) => {
      const newValue = {
        contactName: optionData.contactName,
        contactPhone: optionData.contactPhone,
        [property]: event?.target?.value,
      };
      updateOption({ id: dangerousGoods, value: newValue });
    };
  };

  const onInputChange = (property) => {
    return (event) => {
      const newValue = {
        contactName: optionData.contactName,
        contactPhone: optionData.contactPhone,
        [property]: event?.target?.value,
      };
      updateInput({ id: dangerousGoods, value: newValue });
    };
  };

  return (
    <div>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {checked && (
        <>
          <DangerousGoodsRow>
            <Input
              className={styles['contact-name-field']}
              id='contact-name'
              label={
                <span className={styles['contact-label']}>
                  <FormattedMessage {...messages.contactName} />
                </span>
              }
              onBlur={onBlur('contactName')}
              onChange={onInputChange('contactName')}
              value={optionData.contactName ?? ''}
              version='version2'
            />
          </DangerousGoodsRow>
          <DangerousGoodsRow>
            <Input
              className={styles['contact-field']}
              id='contact-phone'
              label={
                <span className={styles['contact-label']}>
                  <FormattedMessage {...messages.contactPhone} />
                </span>
              }
              onBlur={onBlur('contactPhone')}
              onChange={onInputChange('contactPhone')}
              value={optionData.contactPhone ?? ''}
              version='version2'
            />
          </DangerousGoodsRow>
        </>
      )}
    </div>
  );
};
